import {
  ReferenceData,
  bodyTypesData,
  fuelTypesData,
  transmissionTypeData,
} from '@cinch-nx/data-search'

export interface LocalSuggestionData {
  label: string
  value: string
  searchValue: string
  type: string
}

export const hydrate = (
  data: ReferenceData[],
  type: string,
): LocalSuggestionData[] =>
  data.map(({ label, value }) => ({
    label: `${label} cars`,
    value,
    searchValue: label.toLowerCase(),
    type,
  }))

const LocalSearchData: LocalSuggestionData[] = [
  ...hydrate(fuelTypesData, 'fuelType'),
  ...hydrate(bodyTypesData, 'bodyType'),
  ...hydrate(transmissionTypeData, 'gearbox'),
]

export default LocalSearchData
